var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.row.hasUnreadComments)?_c('i',{staticClass:"fa fa-comment new-comments",attrs:{"title":"You have unread comments"}}):_c('i',{staticClass:"fa fa-comment",attrs:{"title":"You have read all the comments"}})])}
var staticRenderFns = []

export { render, staticRenderFns }